import "./Banner.css";
import banner from "../../../assets/images/banner-1.png";
import React from "react";

const Banner = () => {

    return (
        <div className='Landing__bannerContainer'>
            <img src={banner} alt={"banner"}/>
        </div>
    )
};

export default Banner;